export const sortByBest = () => ({
	type: 'BL_SORT_BY_BEST'
});

export const sortByLatest = () => ({
	type: 'BL_SORT_BY_LATEST'
});
